import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../middleware/dataSlice';

export interface UserInfo {
  companyId: number;
  companyName: string;
  email: string;
  selectedUserInfo: number;
  isUsedMealCard?: boolean | null;
  fastMaxVal?: number | null;
}

export const userAPI = createApi({
  reducerPath: 'userAPI',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getUserInfo: builder.mutation<UserInfo[], void>({
      query: () => ({
        url: `/User/GetUserInfo`,
        method: 'GET',
      }),
      transformResponse: (response: { data: UserInfo[], success: boolean, message: string | null, statusCode: number }) => {
        return response.data || [];
      }
    }),
  }),
});

export const {
  useGetUserInfoMutation,
} = userAPI;
